export default __webpack_public_path__ + "static/media/0090.c7a8b969.jpg";